export default __webpack_public_path__ + "static/media/RD-2.728b7a8c.jpeg";